var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 18.3L2.7 12.7C2.6 12.6 2.52934 12.4917 2.488 12.375C2.446 12.2584 2.425 12.1334 2.425 12C2.425 11.8667 2.446 11.7417 2.488 11.625C2.52934 11.5084 2.6 11.4 2.7 11.3L8.3 5.70005C8.48334 5.51672 8.71267 5.42505 8.988 5.42505C9.26267 5.42505 9.5 5.51672 9.7 5.70005C9.9 5.90005 10 6.13738 10 6.41205C10 6.68738 9.9 6.92505 9.7 7.12505L5.825 11H21C21.2833 11 21.5207 11.0957 21.712 11.287C21.904 11.479 22 11.7167 22 12C22 12.2834 21.904 12.5207 21.712 12.712C21.5207 12.904 21.2833 13 21 13H5.825L9.7 16.9C9.88334 17.0834 9.97934 17.3124 9.988 17.587C9.996 17.8624 9.9 18.1 9.7 18.3C9.51667 18.4834 9.28334 18.575 9 18.575C8.71667 18.575 8.48334 18.4834 8.3 18.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWest);
export default __webpack_public_path__ + "static/media/west.83a4b1fb0a9fdf484f49779bb82711cc.svg";
export { ForwardRef as ReactComponent };